import React from "react";
import { Row, Col } from 'react-bootstrap';
import { IArticle } from "../../types/api/homeApi";
import { NoData } from "../common/NoData";
import { formatDateToDDMMYYYY } from "../../utils/hepler";
import { Link } from "react-router-dom";
import { ISubBlog } from "../../types/features/multiLanguageSlice";
import { useTranslation } from "react-i18next";

const BlogCard: React.FC<{ articles: Array<IArticle> }> = ({ articles }) => {
    const {t} = useTranslation()
    const blog_json = t('blog.blogs', { returnObjects: true })  as ISubBlog[];
    

    return (
        <div>
            <div>
                <section className='blog-section'>
                    <div className="container">
                        <Row>
                            {articles && articles.length > 0 ?
                                articles.map((article: IArticle, index: number) => (
                                    <Col md={6} lg={4} sm={6} className="mb-3" key={"articles_" + index}>
                                        <div className="blog-card">
                                            <div className="date">
                                                <p>{formatDateToDDMMYYYY(article.updated_at, true)}</p>
                                            </div>
                                            <div className="blog-img">
                                                <img src={require('../../assets/images/blog-02.jpg')} alt="img" className="img-fluid"></img>
                                            </div>
                                            <div className="blog-content">
                                                <h4 className="title">{blog_json && blog_json.length>0 && blog_json[index].title}</h4>
                                                <p className="text">{blog_json && blog_json.length>0 && blog_json[index].sub_title}</p>
                                                <Link to={"/blogs/" + article.slug} className="btn btn-gold">{t("home.about_us.read_more")}</Link>
                                            </div>
                                        </div>
                                    </Col>
                                ))
                                : <NoData message="Oops!! No Articles Found." />
                            }
                        </Row>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default BlogCard;